import { useState } from "react";
import { toast } from "react-toastify";
import Alert from '@mui/material/Alert';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { getFileExtension } from "@client/utils";
import { noop } from "@client/shared/constants";
import style from '../style';

const SUPPORTED_FILE_FORMATS = ["mp3", "wav", "x-wav"];
const MAX_ALLOWED_FILE_SIZE = 20;
const MIN_ALLOWED_FILE_DURATION = 3;
const MAX_ALLOWED_FILE_DURATION = 180;

const defaultState = {
	isDraggingOnDropZone: false,
};

const UplaodFile = ({
	audioFile = null,
	onAudioChange = noop,
	showFileUploadLoader = noop,
}) => {
	const [state, setState] = useState(defaultState);

	const handleFileChange = evt => {
	
		showFileUploadLoader(true);
    const file = evt.target.files[0];
    const { name, size } = file;
    const fileExtension = getFileExtension(name);

    if (size > MAX_ALLOWED_FILE_SIZE * 1048576) {
		showFileUploadLoader(false);
      return toast.error(
        `Size of selected file is more than ${MAX_ALLOWED_FILE_SIZE} mb.`
      );
    } else if (!SUPPORTED_FILE_FORMATS.includes(fileExtension.toLowerCase())) {
		showFileUploadLoader(false);
      return toast.error(
        `Only ${SUPPORTED_FILE_FORMATS.join(", ")} formats are supported.`
      );
    }
    let objectURL = URL.createObjectURL(file);
    let mySound = new Audio([objectURL]);
    mySound.addEventListener("canplaythrough", () => {
      URL.revokeObjectURL(objectURL);
      if (
        mySound.duration > MIN_ALLOWED_FILE_DURATION &&
        mySound.duration <= MAX_ALLOWED_FILE_DURATION
      ) {
			console.log(`onAudioChange. Filename: ${name}. Filesize: ${size}`)
			onAudioChange(file);
      } else {
		showFileUploadLoader(false);
        const message =
          mySound.duration < MIN_ALLOWED_FILE_DURATION
            ? `Length of selected file is less than ${MIN_ALLOWED_FILE_DURATION} seconds.`
            : `Length of selected file is more than ${
                MAX_ALLOWED_FILE_DURATION / 60
              } minutes.`;
        return toast.error(message);
      }
    });
  };

	return (
		<Box>
			<Typography variant="body2" sx={{ fontWeight: 'bold' }}>Upload from your computer</Typography>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
          mt: 2,
        }}
      >
				<Box
					sx={{
						px: 4,
						py: 2,
						mr: 1,
						display: 'flex',
						justifyContent: 'center',
						width: '75%',
						...style.dragWrapper,
						...(state.isDraggingOnDropZone ? style.dragging : {}),
					}}
					onDragEnter={() => {
						setState(prevState => ({
							...prevState,
							isDraggingOnDropZone: true,
						}));
					}}
					onDragLeave={() => {
						setState(prevState => ({
							...prevState,
							isDraggingOnDropZone: false,
						}));
					}}
					onDrop={evt => {
						evt.stopPropagation();
						evt.preventDefault();
						evt?.dataTransfer?.files?.length > 1
							? toast.error('Please drop only one file.')
							: handleFileChange({ target: evt.dataTransfer });

						setState(prevState => ({
							...prevState,
							isDraggingOnDropZone: false,
						}));
					}}
					onDragOver={evt => {
						evt.stopPropagation();
						evt.preventDefault();
					}}
				>
					<Tooltip title={state.fileName} placement="top-start">
						{state.isDraggingOnDropZone ? (
							<InsertDriveFileIcon fontSize="small" />
						) : (
							<Typography variant="body2" noWrap>
								{audioFile?.name || "Drop a file from your computer here."}
							</Typography>
						)}
					</Tooltip>
				</Box>
				<Button sx={{ ml: 2 }} variant="contained" component="label" htmlFor="audioFile">
					Browse Files
				</Button>
			</Box>
			<Alert sx={{ mt: 4 }} severity="warning">Max Size: 20MB | 3min, File Types: wav, x-wav, mp3</Alert>
			<input
				hidden
				id="audioFile"
				type="file"
				accept={`audio/${SUPPORTED_FILE_FORMATS.join(",")}`}
				onChange={handleFileChange}
				onClick={(evt) => {
					showFileUploadLoader(true);
					evt.currentTarget.value = "";
					document.body.onfocus = () => {
						showFileUploadLoader(false);
						document.body.onfocus = null;
					} 
				}}
			/>
		</Box>
	)
};

export default UplaodFile;
          